import { render, staticRenderFns } from "./AdvertiseSingleDishMeal.vue?vue&type=template&id=6decc810"
import script from "./AdvertiseSingleDishMeal.vue?vue&type=script&lang=js"
export * from "./AdvertiseSingleDishMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports